"use client";

import useTranslationApi from "@/lib/hooks/useTranslationApi";

import Cart from "@/common/constants/cart";

import Popup from "@/components/Popup";
import Button from "@/components/ui/Button";
import { PopupErrorIcon } from "@/components/icons";

export default function SystemCartErrorPopup() {
  const { t } = useTranslationApi(["system_error", "sorry_client", "accept"]);

  const handleConfirm = () => {
    throw new Error("An error occurred while processing shopping cart");
  };
  return (
    <Popup
      classNameContent={"md:max-w-[600px]"}
      popupId={Cart.POPUP.system_error}
      handleOnClose={handleConfirm}
      centered={true}
    >
      <div className="text-base text-center text-gray-500 flex justify-center flex-col gap-4">
        <span>
          <PopupErrorIcon />
        </span>
        <p className="font-bold mt-2">
          {/* Rất xin lỗi ! */}
          {t("sorry_client")}
        </p>
        <p className="text-sm">
          {/* Hiện hệ thống đang gặp lỗi. Quý khách vui lòng thử lại sau ! */}
          {t("system_error")}
        </p>

        <Button className="w-[70%]" onClick={handleConfirm}>
          {/* Xác nhận */}
          {t("accept")}
        </Button>
      </div>
    </Popup>
  );
}
